import React from 'react';
import { useDispatch } from 'react-redux';
import { togglePopover } from '../../redux/Slices/popoverSlice';
import { FORMAT_TEXT_COMMAND } from 'lexical';
import { FormatUnderlined, StrikethroughS, Code } from '../icons';

const EditorTransformMenu = ({ editor, isStrikethrough, isUnderline, isCode }) => {
    const dispatch = useDispatch();

    const handleFormatClick = (format) => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, format);
        dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));
    };

    return (
        <div className="editor-transform-menu">
            <button
                type="button"
                onClick={() => handleFormatClick('underline')}
                className={`item ${isUnderline ? 'active' : ''}`}
                aria-label="Format Underline"
            >
                <FormatUnderlined size={18} color={'var(--primary-text-color)'} />
                <span className="text">Underline</span>
            </button>

            <button
                type="button"
                onClick={() => handleFormatClick('strikethrough')}
                className={`item ${isStrikethrough ? 'active' : ''}`}
                aria-label="Format Strikethrough"
            >
                <StrikethroughS size={18} color={'var(--primary-text-color)'} />
                <span className="text">Strikethrough</span>
            </button>

            <button
                type="button"
                onClick={() => handleFormatClick('code')}
                className={`item ${isCode ? 'active' : ''}`}
                aria-label="Insert Code"
            >
                <Code size={18} color={'var(--primary-text-color)'} />
                <span className="text">Code</span>
            </button>
        </div>
    );
};

export default EditorTransformMenu;

